import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7481f5nv7: FaireProductEntity = {
  token: "p_a7481f5nv7",
  type: "product",
  name: "Pure Copper Cube",
  brandToken: "b_92q2hhsl",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/455be447f23ca5d48180f5fb204479a2851400931b55aa5fc51d1d5f73b9d8d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a898e51d0e635d54668459944d4d1e0580b349b59d5079a772318897b795b05.jpeg",
  ],
  priceDollars: 29.1,
  description:
    "Get solid and grounded with the Pure Copper Cube. Taking divine inspiration from one of the most supportive and pure shapes in sacred geometry, this copper cube is all about staying strong and conducting the kind of energy you need. Copper is one of the worlds most powerful conductors and is here to bring an anchor of inner wisdom, balanced emotions, and shimmering shades of self-respect.With this cube, I anchor to the ground and connect with all the sacred patterns of the universeDescriptionEver ready to anchor, this Pure Copper Cube is solid from every angle. Four sides are beautifully harmonized and immortalized in singing copper, reminding us of the magic of the Archangel Metatron who oversees the flow of energy and the meaning of life within the mystical cube. Carry with you the fruit of life and the five platonic solids that together capture the sacred shapes and patterns that make up our universe.Here,",
  tags: [],
  msrpDollars: 58.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:08.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
